import { HttpRequest } from "../../api/core/request/HttpRequest";
import { RequestConstants } from "../../api/core/request/RequestConstants";
import { LanguageManager } from "../../game/manager/LanguageManager";
import { Dictionary } from "../../util/collection/Dictionary";
import { EventHandler } from "../../util/event/EventHandler";
import { Logger } from "../../util/log/Logger";
import { FilePath } from "../file/FilePath";
import { Component } from "./Component";
/*
 * ConfigRequest.ts
 */
export class ConfigRequest {
    constructor(url, versionPrefix) {
        this.languageManger = LanguageManager.getInstance();
        this.url = url;
        this.versionPrefix = versionPrefix;
    }
    onComplete(action, scope) {
        this.completeHandler = new EventHandler(action, scope);
    }
    load() {
        this.request = new HttpRequest(RequestConstants.GET, this.url);
        this.request.setContentType(RequestConstants.APPLICATION_XML);
        this.request.setResponseType(RequestConstants.DOCUMENT);
        this.request.onComplete(this.handleConfigComplete, this);
        this.request.send();
    }
    handleConfigComplete() {
        this.processComponents();
        this.completeHandler.call(this);
    }
    processComponents() {
        let document = this.request.getXML();
        this.files = [];
        this.componentsById = new Dictionary();
        this.componentsByKey = new Dictionary();
        let components = document.getElementsByTagName("Component");
        for (let j = 0; j < components.length; j++) {
            const component = components[j];
            this.processComponent(component);
        }
    }
    checkTranslationsExist(component) {
        let langManager = LanguageManager.getInstance();
        let files = component.getElementsByTagName("Files");
        let translationsExist = false;
        for (let i = 0; i < files.length; i++) {
            let file = files[i];
            let children = file.childNodes;
            for (let j = 0; j < children.length; j++) {
                let child = children[j];
                if (child.nodeType == Node.ELEMENT_NODE) {
                    let filePath = this.createFilePath(children[j]);
                    if (filePath.hasLocale()) {
                        let locales = filePath.getLocale().split(",");
                        if (locales.indexOf(langManager.getLocale().getId()) >= 0) {
                            translationsExist = true;
                            break;
                        }
                    }
                }
            }
        }
        if (!translationsExist) {
            Logger.forceLog("Translations for: " + langManager.getLocale().getId() + " missing - falling back to en-GB");
            langManager.setLocale("en-GB");
        }
    }
    processComponent(element) {
        let id = element.getAttribute("id");
        let gameType = element.getAttribute("gameType");
        let roomName = element.getAttribute("roomName");
        let files = element.getElementsByTagName("Files");
        this.componentFiles = [];
        this.id = id;
        for (let i = 0; i < files.length; i++) {
            let file = files[i];
            let children = file.childNodes;
            for (let j = 0; j < children.length; j++) {
                let child = children[j];
                if (child.nodeType == Node.ELEMENT_NODE) {
                    this.processFile(children[j]);
                }
            }
        }
        let component = new Component(id, gameType, roomName, this.componentFiles);
        this.componentsByKey.setValue(component.getKey(), component);
        this.componentsById.setValue(id, id);
    }
    processFile(element) {
        let locale = this.languageManger.getLocale().getId();
        let filePath = this.createFilePath(element);
        let processFile = true;
        if (filePath.hasLocale()) {
            let locales = filePath.getLocale().split(",");
            processFile = locales.indexOf(locale) >= 0;
        }
        else if (filePath.hasNotLocale()) {
            let locales = filePath.getNotLocale().split(",");
            processFile = locales.indexOf(locale) < 0;
        }
        if (processFile) {
            this.componentFiles.push(filePath);
            this.files.push(filePath);
        }
    }
    createFilePath(element) {
        return new FilePath(this.id, element, this.versionPrefix);
    }
    getComponentsById() {
        return this.componentsById;
    }
    getComponentsByKey() {
        return this.componentsByKey;
    }
    getFileByURL(url) {
        for (let i = 0; i < this.files.length; i++) {
            let file = this.files[i];
            if (file.getUrl() == url) {
                return file;
            }
        }
        return null;
    }
    getFiles() {
        return this.files;
    }
    getVersionPrefix() {
        return this.versionPrefix;
    }
}
//# sourceMappingURL=ConfigRequest.js.map